// angular
import { Component } from '@angular/core';
// other libraries
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
@Component({
  selector: 'pwj-tenders-detail-skeleton',
  standalone: true,
  imports: [
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './tenders-detail-skeleton.component.html',
  styleUrl: './tenders-detail-skeleton.component.scss'
})
export class TendersDetailSkeletonComponent {

}
